import { render, staticRenderFns } from "./ModalDescricaoOcorrencia.vue?vue&type=template&id=0aa616fb&scoped=true"
import script from "./ModalDescricaoOcorrencia.vue?vue&type=script&lang=js"
export * from "./ModalDescricaoOcorrencia.vue?vue&type=script&lang=js"
import style0 from "./ModalDescricaoOcorrencia.vue?vue&type=style&index=0&id=0aa616fb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa616fb",
  null
  
)

export default component.exports